import type { Program } from "./schemas/program.js";

// CO-34: athlete-view "Elimina" on a row you authored and also assigned to others.
// Programs-tab "Elimina": not wired yet; wire it via useLibraryDeleteConfirm.

/** Structural: a Program and a Plan both satisfy it, and the rule is one. */
export type AssignableRow = {
  createdBy: string;
  assignedTo?: readonly string[];
};

export type SelfUnassign = { assignedTo: string[]; othersCount: number };

/** `null` ⇒ "Elimina" stays a real DELETE; a `SelfUnassign` ⇒ it becomes a
 *  `PATCH /:id/assignees` that drops the caller. */
export const selfUnassign = (
  row: AssignableRow,
  callerSub: string | null,
  view: Program["authoredAs"] | null,
): SelfUnassign | null => {
  if (view !== "athlete" || callerSub === null) return null;
  if (row.createdBy !== callerSub) return null;
  const assignedTo = row.assignedTo ?? [];
  if (!assignedTo.includes(callerSub)) return null;
  const remaining = assignedTo.filter((sub) => sub !== callerSub);
  // ⭐ Not taste: ProgramAssigneesPatch/PlanAssigneesPatch declare
  // `assignedTo` as .min(1), so a PATCH emptying it is a 400.
  if (remaining.length === 0) return null;
  return { assignedTo: remaining, othersCount: remaining.length };
};
